import React from 'react';

// import { connectHi } from 'react-instantsearch-dom';

import Image from '3-components/Image/Image';
import Icon from '3-components/Icon/Icon';
import Button from '3-components/Buttons/Button';
import Chip from '3-components/Chip/Chip';
import { FormatDistanceNumber } from '3-components/Utils/NumberUtils';
import RenderDistance from './LocationUtils';

/* eslint-disable camelcase */
interface LocationRLHitProps {
    objectID: string,
    name: string,
    type: string,
    intro: string,
    phone: string,
    street: string,
    suburb: string,
    state: string,
    postcode: string,
    '_geoloc': {
        lat: number,
        lng: number
    },
    image: string,
    // "map_link": "https://g.page/AmarooRetirementVillage?share",
    email: string,
    home_number: number,
    bedrooms: string,
    location_tag: [string],
    property_url: string,
    size_types: string,
    other_features: [string],
    home_for_sale?: boolean,
    '_rankingInfo'?: {
        geoDistance?: number
    },
    property_count?: number
}

interface LocationCardRLProps {
    hit: LocationRLHitProps;
    bookTourUrl?: string;
    bookTourTitle?: string;
}

const LocationCardRL = (props: LocationCardRLProps) => {
    const { hit, bookTourUrl, bookTourTitle } = props;
    // eslint-disable-next-line no-underscore-dangle
    const distance = hit._rankingInfo?.geoDistance;
    const formattedDistance = FormatDistanceNumber(distance ? distance / 1000 : undefined);

    return (
        <div className="location-card location-card-rl">
            <Image
                imgSrc={hit.image ? hit.image : '/assets/images/ArticleCardDefault.jpg'}
                imgAlt={`image of ${hit.name}`}
                imgCustomClass="location-card-image-container"
            />
            <div className="location-content location-content-rl">
                {!!hit.property_count && hit.property_count > 0 && (
                    <div className="ribbon ribbon-skin-1">
                        <span>For sale now</span>
                        <span className="ribbon-badge">{hit.property_count}</span>
                    </div>
                )}
                {formattedDistance && RenderDistance(distance, formattedDistance)}
                <h3 className="location-content-title">
                    <a className="location-name-link" href={hit.property_url}>
                        {hit.name}
                    </a>
                </h3>
                <div className="location-content-chip-container">
                    {hit.location_tag && hit.location_tag.map(tag => (<Chip chipTitle={tag} key={tag} />))}
                </div>
                <div className="location-content-desc">
                    {hit.intro}
                </div>
                <div className="location-content-action-container">
                    <Button
                        btnText="Explore"
                        href={hit.property_url}
                        btnCustomClass="action-button"
                    />
                    {bookTourUrl && bookTourTitle && (
                        <Button
                            btnText={bookTourTitle}
                            href={bookTourUrl}
                            btnSkin="2"
                            btnCustomClass="action-button"
                        />
                    )}
                </div>
                <ul className="location-info">
                    <li className="location-info-item">
                        <Icon icon="map-pin" />
                        <span>{`${hit.street}, ${hit.suburb} ${hit.state} ${hit.postcode}`}</span>
                    </li>
                    <li className="location-info-item">
                        <Icon icon="home" />
                        <span>{`${hit.home_number} home${hit.home_number > 1 ? 's' : ''}`}</span>
                    </li>
                    <li className="location-info-item">
                        <Icon icon="bed" />
                        <span>{hit.bedrooms}</span>
                    </li>
                    <li className="location-info-item">
                        <Icon icon="phone" />
                        <a href={`tel:${hit.phone}`}>{hit.phone}</a>
                    </li>
                    <li className="location-info-item">
                        <Icon icon="mail" />
                        <a href={`mailto:${hit.email}`}>{hit.email}</a>
                    </li>
                </ul>
            </div>
        </div>
    );
};
/* eslint-disable camelcase */
export default LocationCardRL;
